const paragraphs = document.querySelectorAll("p.text-wave");
  paragraphs.forEach((p) => {
    p.innerHTML = p.textContent.split("").map(char => { return char === " " ? " " : `<span>${char}</span>`; }).join("");
    
    const chars = p.querySelectorAll("span");

    gsap.to(chars, {
      y: -10,
      repeat: -5,
      yoyo: true,
      ease: "sine.inOut",
      stagger: { each: 0.03, repeat: -5, yoyo: true },
      delay: 2
    });
});  
const lenis = new Lenis({
  smoothWheel: true,
  duration: 1.2,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
});
function raf(time){ lenis.raf(time); requestAnimationFrame(raf); }
requestAnimationFrame(raf);

$(function () {
  // Check WebGL support first
  if (!document.createElement('canvas').getContext('webgl')) {
    console.warn('WebGL disabled');
    return;
  }

  const cfg = {
    resolution: 256,
    dropRadius: 20,
    perturbance: 0.04,
    delay: 700
  };

  // Apply ripple effect to multiple sections
  $('.dream-story-container, .footer-wraper-anime').each(function () {
    const $el = $(this);
    let timer;

    function start() {
      clearTimeout(timer);

      if (!$el.data('r')) {
        $el.ripples({ ...cfg, interactive: false });
        $el.data('r', 1);
      }

      $el.ripples('play').on('mousemove.ripples touchmove.ripples', function (e) {
        const p = e.touches ? e.touches[0] : e;
        const o = $el.offset();
        $el.ripples('drop', p.pageX - o.left, p.pageY - o.top, cfg.dropRadius, 0.03);
      });
    }

    function stop() {
      $el.off('.ripples');
      $el.ripples('pause');

      // Gradual fade out for smoother stop
      let fade = 0.03;
      const fadeStep = setInterval(() => {
        fade -= 0.005;
        if (fade <= 0) {
          clearInterval(fadeStep);
          $el.ripples('destroy');
          $el.removeData('r');
        } else {
          $el.ripples('set', 'perturbance', fade);
        }
      }, 50);
    }

    // Event triggers for hover/touch
    $el.on('mouseenter touchstart', start)
       .on('mouseleave touchend touchcancel', stop);
  });
});
